<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.99983 0.19043C3.24041 0.19043 0.188477 3.24277 0.188477 7.00244C0.188477 10.762 3.24041 13.8144 6.99983 13.8144C10.7601 13.8144 13.8121 10.762 13.8121 7.00244C13.8121 3.24277 10.7601 0.19043 6.99983 0.19043ZM6.99983 1.77508C9.88505 1.77508 12.2278 4.1174 12.2278 7.00244C12.2278 9.8874 9.88505 12.2297 6.99983 12.2297C4.11548 12.2297 1.77277 9.8874 1.77277 7.00244C1.77277 4.1174 4.11548 1.77508 6.99983 1.77508Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'CircleEmpty'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
